// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type QueryPlanQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  queryId: Types.Scalars["ID"]["input"];
  originalPlanId: Types.Scalars["ID"]["input"];
}>;

export type QueryPlanQuery = {
  __typename?: "GraphqlQuery";
  getQueryPlan?: {
    __typename?: "QueryPlan";
    id: string;
    originalPlanId: string;
    explainPlan?: string | null;
    planCapturedTime?: number | null;
    planFingerprint?: string | null;
    totalCost?: number | null;
    annotatedJson?: any | null;
  } | null;
  getQueryDetails: {
    __typename?: "Query";
    id: string;
    normalizedQuery: string;
    truncatedQuery: string;
  };
};

export const QueryPlanDocument = gql`
  query QueryPlan($databaseId: ID!, $queryId: ID!, $originalPlanId: ID!) {
    getQueryPlan(
      databaseId: $databaseId
      queryId: $queryId
      originalPlanId: $originalPlanId
    ) {
      id
      originalPlanId
      explainPlan
      planCapturedTime
      planFingerprint
      totalCost
      annotatedJson
    }
    getQueryDetails(databaseId: $databaseId, queryId: $queryId) {
      id
      normalizedQuery
      truncatedQuery
    }
  }
`;

/**
 * __useQueryPlanQuery__
 *
 * To run a query within a React component, call `useQueryPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPlanQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      queryId: // value for 'queryId'
 *      originalPlanId: // value for 'originalPlanId'
 *   },
 * });
 */
export function useQueryPlanQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryPlanQuery,
    QueryPlanQueryVariables
  > &
    (
      | { variables: QueryPlanQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QueryPlanQuery, QueryPlanQueryVariables>(
    QueryPlanDocument,
    options,
  );
}
export function useQueryPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryPlanQuery,
    QueryPlanQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<QueryPlanQuery, QueryPlanQueryVariables>(
    QueryPlanDocument,
    options,
  );
}
// @ts-ignore
export function useQueryPlanSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryPlanQuery,
    QueryPlanQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<QueryPlanQuery, QueryPlanQueryVariables>;
export function useQueryPlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<QueryPlanQuery, QueryPlanQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  QueryPlanQuery | undefined,
  QueryPlanQueryVariables
>;
export function useQueryPlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<QueryPlanQuery, QueryPlanQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<QueryPlanQuery, QueryPlanQueryVariables>(
    QueryPlanDocument,
    options,
  );
}
export type QueryPlanQueryHookResult = ReturnType<typeof useQueryPlanQuery>;
export type QueryPlanLazyQueryHookResult = ReturnType<
  typeof useQueryPlanLazyQuery
>;
export type QueryPlanSuspenseQueryHookResult = ReturnType<
  typeof useQueryPlanSuspenseQuery
>;
export type QueryPlanQueryResult = Apollo.QueryResult<
  QueryPlanQuery,
  QueryPlanQueryVariables
>;
